import colors from "colors";
import { IconProps } from "./types";

export default function IcoExternalLink({
	color = colors.neutral["low-pure-500"],
	size = "22"
}: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 11.6364V19H1V1H8.36364M12.4547 1H19.0002M19.0002 1V7.54545M19.0002 1L8.5022 11.5011"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
